export default __webpack_public_path__ + "static/media/t1.343669e1.jpg";